import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";

import Main from "../components/Main";
import Article from "../components/Main/Article";
import PageHeader from "../components/Page/PageHeader";
import Content from "../components/Main/Content";
import Footer from "../components/Footer/Footer";

const styles = theme => ({});

const Support = () => {
  return (
    <Main>
      <Article>
        <PageHeader title="Privacy Policy" />
        <Content>
          <br />
          <br />
          <a href="https://projectsurfhelmet.com/Privacy-Policy.pdf" target="_blank">
            Privacy Policy
          </a>
          <br />
          <br />
          <br />
          <br />
        </Content>
        {/*<Form />*/}
      </Article>
      <Footer />
    </Main>
  );
};

Support.propTypes = {
  classes: PropTypes.object.isRequired
};

export default injectSheet(styles)(Support);



// WEBPACK FOOTER //
// ./src/pages/privacy.js